export const DAY = 1000 * 60 * 60 * 24

export const PARALLEL_CALL_OPTIONS = [1, 2, 3, 4, 5, 6] as const

export const machineIdFromUrl = (): string =>
  new URLSearchParams(window.location.search).get('machine_id') || ''

export const toTimestamp = (value?: string | number | Date): number | undefined => {
  if (value === undefined) return undefined
  const timestamp = new Date(value).getTime()
  return Number.isFinite(timestamp) ? timestamp : undefined
}

export const formatSeconds = (ms?: number): string =>
  ms === undefined ? '-' : `${(ms / 1000).toFixed(1)}s`

export const formatDate = (ms?: number): string =>
  ms === undefined ? '-' : new Date(ms).toISOString().replace('T', ' ').slice(0, 19)

export const formatClock = (ms?: number): string =>
  ms === undefined ? '-' : new Date(ms).toISOString().slice(11, 23)
